export enum HelpsRoutingEnum {
  Listing = 'aides',
  Help = 'aide/:articleSlug',
}
